import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Instagram } from 'lucide-react';

const artists = [
  {
    name: 'Lena',
    url: 'https://www.instagram.com/gaiamundi2024/',
    glow: 'rgba(138,201,38,0.45)',
  },
  {
    name: 'Mel',
    url: 'https://www.instagram.com/meijam.miricou',
    glow: 'rgba(255,105,180,0.45)',
  },
];

export const SocialHub = () => {
  const [activeMobile, setActiveMobile] = useState(null);

  return (
    <>
      {/* ================= DESKTOP – BOTTOM LEFT ================= */}
      <div className="fixed z-40 hidden lg:flex left-6 bottom-6">
        <div className="flex flex-col gap-4">

          {artists.map((artist) => (
            <motion.a
              key={artist.name}
              href={artist.url}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ x: 8 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="relative group"
            >
              <div
                className="flex items-center gap-3 px-4 py-3 transition-all duration-300 glass rounded-2xl"
              >
                <Instagram
                  size={18}
                  className="transition opacity-80 group-hover:opacity-100"
                />

                <div className="flex flex-col leading-tight">
                  <span className="text-[12px] tracking-widest font-semibold">
                    {artist.name}
                  </span>
                  <span className="text-[9px] opacity-70">
                    Instagram
                  </span>
                </div>
              </div>

              {/* Soft Glow */}
              <div
                className="absolute inset-0 transition duration-300 opacity-0 rounded-2xl group-hover:opacity-100"
                style={{
                  boxShadow: `0 0 35px ${artist.glow}`,
                }}
              />
            </motion.a>
          ))}

        </div>
      </div>

      {/* ================= MOBILE DOCK ================= */}
      <div className="fixed z-40 -translate-x-1/2 lg:hidden bottom-5 left-1/2">
        <div className="flex items-center gap-8 px-6 py-3 rounded-full shadow-xl glass">
          {artists.map((artist) => (
            <button
              key={artist.name}
              onClick={() =>
                setActiveMobile(
                  activeMobile === artist.name ? null : artist.name
                )
              }
              className="flex flex-col items-center text-xs font-medium transition opacity-80 hover:opacity-100"
            >
              <Instagram size={18} />
              <span className="mt-1">{artist.name}</span>
            </button>
          ))}
        </div>

        <AnimatePresence>
          {activeMobile && (
            <motion.div
              key={activeMobile}
              initial={{ opacity: 0, y: 25, scale: 0.95 }}
              animate={{ opacity: 1, y: -14, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.95 }}
              transition={{ duration: 0.25 }}
              className="p-4 mt-3 text-center glass rounded-2xl"
            >
              <a
                href={artists.find(a => a.name === activeMobile).url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-sm font-semibold text-[var(--accent)]"
              >
                <Instagram size={16} />
                Open {activeMobile}
              </a>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};